export const SWITCH_BS_SIZES = ['mini', 'small', 'normal', 'large'];
export const SWITCH_COLORS = ['primary', 'info', 'success', 'warning', 'danger', 'default'];